import { render, staticRenderFns } from "./updateCertifiedModal.vue?vue&type=template&id=4fa25525&scoped=true&"
import script from "./updateCertifiedModal.vue?vue&type=script&lang=js&"
export * from "./updateCertifiedModal.vue?vue&type=script&lang=js&"
import style0 from "./updateCertifiedModal.vue?vue&type=style&index=0&id=4fa25525&prod&lang=less&scoped=true&"
import style1 from "./updateCertifiedModal.vue?vue&type=style&index=1&id=4fa25525&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa25525",
  null
  
)

export default component.exports